"use client"

import { HttpTypes } from "@medusajs/types"
import ProductPrice from "../product-price"
import ProductVariantsTable from "../product-variants-table"
import { B2BCustomer } from "@/types/global"
import { WarehouseMetadata } from "@/lib/data/inventory"

type ProductActionsProps = {
  product: HttpTypes.StoreProduct
  region: HttpTypes.StoreRegion
  customer?: B2BCustomer | null
  warehouseStock?: Record<string, number>
  warehouseMetadata?: Record<string, WarehouseMetadata>
}

export default function ProductActions({
  product,
  region,
  customer,
  warehouseStock,
  warehouseMetadata,
}: ProductActionsProps) {
  return (
    <>
      <div className="flex flex-col gap-y-2 w-full">
        <ProductPrice product={product} />
        <ProductVariantsTable product={product} region={region} warehouseStock={warehouseStock} warehouseMetadata={warehouseMetadata} />
      </div>
    </>
  )
}
